var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"dusk":"looker-embed"}},[_c('iframe',{ref:"iframe",style:({ width: '100%', height: _vm.height }),attrs:{"scrolling":"no","src":_vm.embedUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }